export default __webpack_public_path__ + "static/media/yank.975b0e94.webp";